import { useCallback, useEffect, useState } from 'react'
import { exposeStrapiError } from 'utils'

export default function useSalesforceReview(row, loadIdentityReview, companyName) {
  const [review, setReview] = useState(null)
  const [reviewLoading, setReviewLoading] = useState(!!loadIdentityReview)
  const [reviewError, setReviewError] = useState('')
  const [contactId, setContactId] = useState('')
  const [accountId, setAccountId] = useState('')
  const [allowAccountChange, setAllowAccountChange] = useState(false)
  const [queryAccountId, setQueryAccountId] = useState('')
  const [createNew, setCreateNew] = useState(false)
  const [reason, setReason] = useState('')
  const [attempt, setAttempt] = useState(0)
  const reloadReview = useCallback(() => {
    setContactId(''); setAccountId(''); setQueryAccountId(''); setAllowAccountChange(false)
    setCreateNew(false); setReason(''); setAttempt(value => value + 1)
  }, [])
  useEffect(() => {
    setContactId(''); setAccountId(''); setQueryAccountId(''); setAllowAccountChange(false)
    setCreateNew(false); setReason('')
  }, [row.id, companyName])

  useEffect(() => {
    let active = true
    if (!loadIdentityReview) return undefined
    setReviewLoading(true)
    setReviewError('')
    const timer = window.setTimeout(() => { Promise.resolve().then(() => (queryAccountId ? loadIdentityReview(row.id, companyName, queryAccountId) : loadIdentityReview(row.id, companyName))).then(result => {
      if (!active) return
      if (!result?.ok || !Array.isArray(result?.data?.contacts) || !Array.isArray(result?.data?.accounts)
        || !Array.isArray(result?.data?.leads) || typeof result?.data?.fingerprint !== 'string') {
        exposeStrapiError(result?.data)
        setReviewError(result?.data?.message || 'Unable to load current Salesforce records. Retry before confirming.')
        setReview(null)
      } else {
        setReview(result.data)
        setContactId(previous => result.data.contacts.some(contact => contact.id === previous && contact.selectable) ? previous : '')
      }
      setReviewLoading(false)
    }).catch(() => {
      if (!active) return
      setReviewError('Unable to load current Salesforce records. Retry before confirming.')
      setReviewLoading(false)
    })
    }, companyName !== undefined ? 250 : 0)
    return () => { active = false; window.clearTimeout(timer) }
  }, [loadIdentityReview, row.id, attempt, companyName, queryAccountId])

  const chooseAccount = id => {
    setAccountId(id)
    setAllowAccountChange(false)
    if (review?.version === 2 && !review.partnerFlow && id !== queryAccountId) {
      setQueryAccountId(id)
      setReviewLoading(true)
      setCreateNew(false)
      setReason('')
    }
  }

  return { createNew, setCreateNew: value => { setCreateNew(value); if (value) setContactId('') }, reason, setReason, review, reviewLoading, reviewError, reloadReview, contactId, accountId, allowAccountChange,
    selectedContact: review?.contacts?.find(contact => contact.id === contactId),
    selectedAccount: review?.accounts?.find(account => account.id === accountId),
    setContactId: id => {
      setContactId(id); setCreateNew(false); setReason(''); setAllowAccountChange(false)
      if (review?.version === 2 && !review.partnerFlow) chooseAccount(review.contacts.find(contact => contact.id === id)?.accountId || accountId)
      else setAccountId('')
    },
    setAccountId: chooseAccount, setAllowAccountChange }
}
